(() => {
  if (window.__dlSourcePicker0917d) return;
  window.__dlSourcePicker0917d = true;
  function boot(root){
    if(!root || root.dataset.dlSourcePickerD==='1') return;
    root.dataset.dlSourcePickerD='1';
    const upload=root.querySelector('[data-upload]');
    if(!upload) return;
    let activeIndex=0, chooserUpload=false;
    const nativeClick=upload.click.bind(upload);

    const overlay=document.createElement('div');
    overlay.className='dl-source-picker'; overlay.hidden=true;
    overlay.innerHTML='<div class="dl-source-picker__card" role="dialog" aria-modal="true"><button type="button" class="dl-source-picker__close" aria-label="Close">×</button><div class="dl-source-picker__title">CHOOSE YOUR DROP IMAGE</div><button type="button" class="dl-source-picker__action" data-source-upload>UPLOAD IMAGE</button><button type="button" class="dl-source-picker__action dl-source-picker__library" data-source-library>SELECT FROM LIBRARY</button><button type="button" class="dl-source-picker__cancel" data-source-cancel>CANCEL</button></div>';
    const style=document.createElement('style');
    style.textContent='.dl-source-picker[hidden]{display:none!important}.dl-source-picker{position:fixed;inset:0;z-index:2147483000;display:grid;place-items:center;padding:20px;background:rgba(0,0,0,.48)}.dl-source-picker__card{position:relative;width:min(420px,calc(100vw - 32px));background:#fff;border-radius:22px;padding:26px 20px 20px;box-shadow:0 24px 70px rgba(0,0,0,.28);text-align:center}.dl-source-picker__title{font-size:20px;line-height:1.2;font-weight:900;letter-spacing:.02em;margin:2px 34px 20px}.dl-source-picker__action,.dl-source-picker__cancel{width:100%;min-height:52px;border-radius:14px;font-weight:900;font-size:15px;cursor:pointer}.dl-source-picker__action{border:2px solid #111;background:#111;color:#fff;margin:0 0 12px}.dl-source-picker__library{background:#fff;color:#111}.dl-source-picker__cancel{border:0;background:transparent;color:#555;margin-top:2px}.dl-source-picker__close{position:absolute;right:12px;top:10px;border:0;background:transparent;color:#111;font-size:30px;line-height:1;width:40px;height:40px;cursor:pointer}@media(max-width:480px){.dl-source-picker{padding:16px}.dl-source-picker__card{width:100%;border-radius:20px;padding:24px 16px 16px}}';
    document.head.appendChild(style); document.body.appendChild(overlay);
    const close=()=>{overlay.hidden=true;document.documentElement.style.removeProperty('overflow')};
    const open=()=>{overlay.hidden=false;document.documentElement.style.setProperty('overflow','hidden')};
    overlay.querySelector('.dl-source-picker__close').onclick=close;
    overlay.querySelector('[data-source-cancel]').onclick=close;
    overlay.onclick=e=>{if(e.target===overlay)close()};

    Array.from(root.querySelectorAll('[data-slot]')).forEach((tile,index)=>{
      tile.addEventListener('click',e=>{
        if(!e.isTrusted || e.target.closest('.dl-drop-delete') || tile.disabled || tile.getAttribute('aria-disabled')==='true' || root.dataset[`dlSaved${index+1}`]==='1' || root.dataset.dlUploadBusy==='1' || root.dataset.dlBgBusy==='1') return;
        e.preventDefault(); e.stopImmediatePropagation();
        activeIndex=index; root.__dlSetActive?.(index); open();
      },true);
    });

    overlay.querySelector('[data-source-upload]').onclick=e=>{
      e.preventDefault(); e.stopPropagation();
      root.__dlSetActive?.(activeIndex); chooserUpload=true; close(); nativeClick();
    };
    overlay.querySelector('[data-source-library]').onclick=e=>{
      e.preventDefault(); e.stopPropagation(); root.__dlSetActive?.(activeIndex); close();
      const actual=root.querySelector('.dl-library-button');
      const proxy=root.querySelector('.dl-library-proxy');
      (actual||proxy)?.click();
    };

    /* Critical fix: capture the File before droplit-builder-v2.js clears input.value. */
    upload.addEventListener('change',e=>{
      if(!chooserUpload) return;
      chooserUpload=false;
      const file=e.target.files && e.target.files[0];
      if(!file) return;
      const index=activeIndex;
      root.__dlSetActive?.(index);
      const reader=new FileReader();
      reader.onload=()=>{
        const src=String(reader.result||'');
        if(!src) return;
        const payload={preview:src,originalPreview:src,file,originalFile:file,title:file.name||`Drop ${index+1}`,source:'upload'};
        if(typeof root.__dlAssign==='function') root.__dlAssign(payload,index);
        else {
          const img=root.querySelector('[data-preview]');
          if(img){img.src=src;img.hidden=false;}
        }
      };
      reader.readAsDataURL(file);
    },true);
  }
  const init=()=>document.querySelectorAll('.dl').forEach(boot);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
  document.addEventListener('shopify:section:load',init);
})();